import { type TextInputProps as MantineTextInputProps } from '@mantine/core';
import { CountryCode } from 'libphonenumber-js';
import { Ref } from 'react';
import PhoneInput, {
  type FeatureProps,
  type Value,
} from 'react-phone-number-input/input';

import { TextInput, type TextInputProps } from '../v2/TextInput';

type IPhoneInputProps = Omit<
  FeatureProps<TextInputProps>,
  'country' | 'value' | 'onChange' | 'onBlur' | 'ref' | 'label' | 'required'
> & {
  value?: string | null;
  onChange?: (value: string | null) => void;
  onBlur?: () => void;
  ref?: Ref<HTMLInputElement>;
  country?: CountryCode;
  label?: string;
  placeholder?: string;
  isRequired?: boolean;
  styles?: MantineTextInputProps['styles'];
};

export const ZorroPhoneInput = ({
  country = 'US',
  label: labelProp = 'Phone',
  placeholder = 'Phone',
  isRequired = false,
  size = 'md',
  value,
  onChange,
  ...props
}: IPhoneInputProps) => {
  const label = isRequired ? `${labelProp}*` : labelProp;

  return (
    <PhoneInput
      // Cast required: react-phone-number-input expects a different component signature
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      inputComponent={TextInput as any}
      placeholder={placeholder}
      country={country}
      label={label}
      size={size}
      {...props}
      value={(value ?? undefined) as Value | undefined}
      // The library represents empty as undefined, but RHF reserves
      // undefined for "use the default value", so empty is emitted as null.
      onChange={(next?: Value) => onChange?.(next ?? null)}
    />
  );
};
